

import React, { useState, useEffect } from 'react';
import { Download, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useMyContext } from '../../../context/MyContext';
import NavBar from '../../../component/b2c/navBar/navBar';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import { Base_Url, forwardorderlistall } from '../../../config/config';
import { TbReportSearch } from "react-icons/tb";
import '../../../css/custom-scrollbar.css'
import { toast } from 'react-toastify';
import Papa from "papaparse";
import FullPageLoader from '../../../../src/component/fullPageLoader/fullPageLoader'

// const ReportsDropdown = () => {
//   const { isDarkMode, isToggleSidebar } = useMyContext();
//   const navigate = useNavigate();
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [dateRanges, setDateRanges] = useState({
//     'MIS Report': { startDate: '', endDate: '' },
//     'Order Product Report': { startDate: '', endDate: '' },
//     'Current Shipment Report': { startDate: '', endDate: '' },
//     'NDR Report': { startDate: '', endDate: '' }
//   });

//   const validateDate = (date) => {
//     const selectedDate = new Date(date);
//     const today = new Date();
//     return selectedDate <= today;
//   };

//   const reports = [
//     {
//       name: 'MIS Report',
//       description: 'Management information system report with detailed order',
//       columns: ['order_id',
//         'user_id',
//         'awb_number',
//         'pickup_name',
//         'pickup_address',
//         'pickup_city',
//         'pickup_pin_code',
//         'pickup_country',
//         'pickup_phone',
//         'first_name',
//         'last_name',
//         'drop_address',
//         'drop_pin',
//         'drop_city',
//         'drop_state',
//         'phone',
//         'email',
//         'payment_mode',
//         'total_amount',
//         'created_at',
//         'partner',
//         'warehouse_id',
//         'shipment_type',
//         'payment_id',
//         'phone',
//         'drop_pin',
//         'drop_city',
//         'drop_state',
//         'drop_address',
//         'product_desc',
//         'cod_amount',
//         'quantity',
//         'width',
//         'height',
//         'length',
//         'weight',
//         'shipping_mode',
//         'address_type',
//         'request_id',
//         'is_ndr',
//         'status',
//         'created_at',
//         'debit_amount']
//     },
//     {
//       name: 'Order Product Report',
//       description: 'Detailed product information for all orders',
//       columns:['order_id', 'user_id', 'first_name', 'last_name', 'product_desc', 'quantity', 'sku', 'awb_number', 'created_at']
//     },
//     {
//       name: 'Current Shipment Report',
//       description: 'Real-time status of all active shipments',
//       columns:  ['order_id', 'user_id', 'first_name', 'last_name', 'product_desc', 'quantity', 'sku', 'awb_number', 'drop_address', 'drop_city', 'drop_state', 'drop_pin', 'status']
//     },
//     {
//       name: 'NDR Report',
//       description: 'Non-delivery report with attempt details and reasons',
//       columns: ['order_id', 'first_name', 'user_id', 'last_name', 'phone', 'product_desc', 'awb_number', 'drop_address', 'drop_pin', 'drop_city', 'drop_state', 'status', 'ndr_attempt', 'updated_at', 'ndr_reason']
//     }
//   ];

//   useEffect(() => {
//     fetchOrderData();
//   }, []);

//   const fetchOrderData = async () => {
//     setLoading(true);
//     setError(null);
//     const token = localStorage.getItem('token');
//     const cusid = localStorage.getItem('cus_id');

//     try {
//       const response = await fetch(Base_Url + forwardorderlistall, {
//         method: 'GET',
//         headers: {
//           token,
//           cus_id: cusid,
//           'Content-Type': 'application/json',
//         },
//       });
//       const result = await response.json();

//       if (response.ok) {
//         setData(result.data || []);
//       } else {
//         setError(result.message);
//       }
//     } catch (error) {
//       setError('Failed to fetch data. Please try again later.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDateChange = (reportName, field, value) => {
//     if (value && !validateDate(value)) {
//       toast.error('Future dates are not allowed');
//       return;
//     }

//     // For end date, check if it's not before start date
//     if (field === 'endDate' && value) {
//       const startDate = dateRanges[reportName].startDate;
//       if (startDate && new Date(value) < new Date(startDate)) {
//         toast.error('End date cannot be before start date');
//         return;
//       }
//     }

//     // For start date, check if it's not after end date
//     if (field === 'startDate' && value) {
//       const endDate = dateRanges[reportName].endDate;
//       if (endDate && new Date(value) > new Date(endDate)) {
//         toast.error('Start date cannot be after end date');
//         return;
//       }
//     }

//     setDateRanges(prev => ({
//       ...prev,
//       [reportName]: {
//         ...prev[reportName],
//         [field]: value
//       }
//     }));
//   };

//   const isDownloadDisabled = (reportName) => {
//     const { startDate, endDate } = dateRanges[reportName];
//     return loading || !startDate || !endDate;
//   };

//   const downloadCSV = async (report) => {
//     const { startDate, endDate } = dateRanges[report.name];

//     let filteredData = data;
//     if (startDate && endDate) {
//       filteredData = data.filter(item => {
//         const itemDate = new Date(item.created_at);
//         return itemDate >= new Date(startDate) && itemDate <= new Date(endDate);
//       });
//     }

//     // Transform data to match report columns
//     const csvData = filteredData.map(item => {
//       const row = {};
//       report.columns.forEach(column => {
//         const key = column.toLowerCase().replace(' ', '_');
//         row[column] = item[key] || 'N/A';
//       });
//       return row;
//     });

//     // Use Papa Parse to convert to CSV
//     const csv = Papa.unparse(csvData, {
//       header: true,
//       quotes: true,
//       quoteChar: '"',
//       escapeChar: '"'
//     });

//     const blob = new Blob([csv], { type: 'text/csv' });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `${report.name}_${startDate || 'all'}_to_${endDate || 'all'}.csv`;
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     URL.revokeObjectURL(url);
//   };

//   return (
//     <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor ' : ''}`}>
//       <div className="z-10">
//         <NavBar />
//       </div>

//       <div className="flex flex-1 overflow-hidden">
//         {isToggleSidebar && (
//           <div className="w-64 flex-shrink-0">
//             <Sidebar />
//           </div>
//         )}
//         <div className={`shadow-custom-light ml-3 mt-6 mb-6 custom-scrollbar mr-6 w-full rounded-custom overflow-y-auto dark:shadow-custom-dark p-4 ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : ''}`}>
//           <div className="flex-1 overflow-auto p-6">
//             <div className="mb-6 flex items-center justify-between">
//               <button className="text-xl sm:text-2xl font-bold mb-4 bg-customPurple sm:mb-6 hover:bg-purple-700 text-white font-sans px-2 sm:px-6 py-2 sm:py-2 rounded h-[40px] w-full sm:w-full flex items-center justify-center">
//                 <TbReportSearch className="mr-2" size={24} />
//                 Report Dashboard
//               </button>
//             </div>

//             {error && (
//               <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-md">
//                 <p className="text-red-800">{error}</p>
//               </div>
//             )}

//             <div className="grid gap-6 md:grid-cols-2 dark:bg-darkmodeColor ">
//               {reports.map((report) => (
//                 <div
//                   key={report.name}
//                   className="bg-white dark:bg-darkmodeColor rounded-custom shadow-custom-light dark:shadow-custom-dark transition-shadow p-6"
//                 >
//                   <div className="mb-4">
//                     <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
//                       {report.name}
//                     </h2>
//                     <p className="text-sm text-gray-500 dark:text-gray-400">
//                       {report.description}
//                     </p>
//                   </div>

//                   <div className="space-y-4">
//                     <div className="grid grid-cols-2 gap-4">
//                       <div className="space-y-2">
//                         <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
//                           Start Date
//                         </label>
//                         <input
//                           type="date"
//                           value={dateRanges[report.name].startDate}
//                           onChange={(e) => handleDateChange(report.name, 'startDate', e.target.value)}
//                           className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                         />
//                       </div>
//                       <div className="space-y-2">
//                         <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
//                           End Date
//                         </label>
//                         <input
//                           type="date"
//                           value={dateRanges[report.name].endDate}
//                           onChange={(e) => handleDateChange(report.name, 'endDate', e.target.value)}
//                           className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                         />
//                       </div>
//                     </div>
//                     <button
//                       onClick={() => downloadCSV(report)}
//                       disabled={isDownloadDisabled(report.name)}
//                       className="w-full flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-customPurple hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed"
//                     >
//                       <Download className="mr-2 h-4 w-4" />
//                       Download CSV
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };


const ReportsDropdown = () => {
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const navigate = useNavigate();
  const [isPageLoading, isSetPageLoading] = useState();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dateRanges, setDateRanges] = useState({
    'MIS Report': { startDate: '', endDate: '' },
    'Order Product Report': { startDate: '', endDate: '' },
    'Current Shipment Report': { startDate: '', endDate: '' },
    'NDR Report': { startDate: '', endDate: '' }
  });

  const validateDate = (date) => {
    const selectedDate = new Date(date);
    const today = new Date();
    return selectedDate <= today;
  };

  // Fixed column mapping - mapping display names to actual API keys
  const reports = [
    {
      name: 'MIS Report',
      description: 'Management information system report with detailed order',
      columnMapping: {
        'Order ID': 'order_id',
        'User ID': 'user_id',
        'AWB Number': 'awb_number',
        'Pickup Name': 'pickup_name',
        'Pickup Address': 'pickup_address',
        'Pickup City': 'pickup_city',
        'Pickup Pin Code': 'pickup_pincode',
        'Pickup Country': 'pickup_country',
        'Pickup Phone': 'pickup_phone',
        'First Name': 'first_name',
        'Last Name': 'last_name',
        'Drop Address': 'drop_address',
        'Drop Pin': 'drop_pin',
        'Drop City': 'drop_city',
        'Drop State': 'drop_state',
        'Phone': 'phone',
        'Email': 'email',
        'Payment Mode': 'payment_mode',
        'Total Amount': 'total_amount',
        'Created At': 'created_at',
        'Partner': 'partner',
        'Warehouse ID': 'warehouse_id',
        'Shipment Type': 'shipment_type',
        'Payment ID': 'payment_id',
        'Product Description': 'product_desc',
        'COD Amount': 'cod_amount',
        'Quantity': 'quantity',
        'Width': 'width',
        'Height': 'height',
        'Length': 'length',
        'Weight': 'weight',
        'Shipping Mode': 'shipping_mode',
        'Address Type': 'address_type',
        'Request ID': 'request_id',
        'Is NDR': 'is_ndr',
        'Status': 'status',
        'Debit Amount': 'debit_amount'
      }
    },
    {
      name: 'Order Product Report',
      description: 'Detailed product information for all orders',
      columnMapping: {
        'Order ID': 'order_id',
        'User ID': 'user_id',
        'First Name': 'first_name',
        'Last Name': 'last_name',
        'Product Description': 'product_desc',
        'Quantity': 'quantity',
        'SKU': 'sku', // Note: This field might not exist in your API response
        'AWB Number': 'awb_number',
        'Created At': 'created_at'
      }
    },
    {
      name: 'Current Shipment Report',
      description: 'Real-time status of all active shipments',
      columnMapping: {
        'Order ID': 'order_id',
        'User ID': 'user_id',
        'First Name': 'first_name',
        'Last Name': 'last_name',
        'Product Description': 'product_desc',
        'Quantity': 'quantity',
        'SKU': 'sku', // Note: This field might not exist in your API response
        'AWB Number': 'awb_number',
        'Drop Address': 'drop_address',
        'Drop City': 'drop_city',
        'Drop State': 'drop_state',
        'Drop Pin': 'drop_pin',
        'Status': 'status'
      }
    },
    {
      name: 'NDR Report',
      description: 'Non-delivery report with attempt details and reasons',
      columnMapping: {
        'Order ID': 'order_id',
        'First Name': 'first_name',
        'User ID': 'user_id',
        'Last Name': 'last_name',
        'Phone': 'phone',
        'Product Description': 'product_desc',
        'AWB Number': 'awb_number',
        'Drop Address': 'drop_address',
        'Drop Pin': 'drop_pin',
        'Drop City': 'drop_city',
        'Drop State': 'drop_state',
        'Status': 'status',
        'NDR Attempt': 'ndr_attempt', // Note: This field might not exist in your API response
        'Updated At': 'updated_at',
        'NDR Reason': 'ndr_reason' // Note: This field might not exist in your API response
      }
    }
  ];

  useEffect(() => {
    fetchOrderData();
  }, []);
  const fetchOrderData = async () => {
    setLoading(true);
    setError(null);
    isSetPageLoading(true);
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    try {
      const response = await fetch(Base_Url + forwardorderlistall, {
        method: 'GET',
        headers: {
          token,
          cus_id: cusid,
          'Content-Type': 'application/json',
        },
      });
      const result = await response.json();

      if (response.ok) {
        setData(result.data || []);
        isSetPageLoading(false);
      } else {
        setError(result.message);
        isSetPageLoading(false);
      }
    } catch (error) {
      setError('Failed to fetch data. Please try again later.');
      isSetPageLoading(false);

    } finally {
      setLoading(false);
      isSetPageLoading(false);
    }
  };

  const handleDateChange = (reportName, field, value) => {
    if (value && !validateDate(value)) {
      toast.error('Future dates are not allowed');
      return;
    }

    // For end date, check if it's not before start date
    if (field === 'endDate' && value) {
      const startDate = dateRanges[reportName].startDate;
      if (startDate && new Date(value) < new Date(startDate)) {
        toast.error('End date cannot be before start date');
        return;
      }
    }

    // For start date, check if it's not after end date
    if (field === 'startDate' && value) {
      const endDate = dateRanges[reportName].endDate;
      if (endDate && new Date(value) > new Date(endDate)) {
        toast.error('Start date cannot be after end date');
        return;
      }
    }

    setDateRanges(prev => ({
      ...prev,
      [reportName]: {
        ...prev[reportName],
        [field]: value
      }
    }));
  };

  const isDownloadDisabled = (reportName) => {
    const { startDate, endDate } = dateRanges[reportName];
    return loading || !startDate || !endDate;
  };

  const downloadCSV = async (report) => {
    const { startDate, endDate } = dateRanges[report.name];

    // Filter data by date range if provided
    let filteredData = data;
    if (startDate && endDate) {
      filteredData = data.filter(item => {
        const itemDate = new Date(item.created_at);
        const start = new Date(startDate);
        const end = new Date(endDate);
        // Set end date to end of day for proper comparison
        end.setHours(23, 59, 59, 999);
        return itemDate >= start && itemDate <= end;
      });
    }

    // Check if we have data to export
    if (filteredData.length === 0) {
      toast.error('No data found for the selected date range');
      return;
    }

    // Transform data using the column mapping
    const csvData = filteredData.map(item => {
      const row = {};
      Object.entries(report.columnMapping).forEach(([displayName, apiKey]) => {
        // Get the value from the API response using the correct key
        row[displayName] = item[apiKey] !== undefined && item[apiKey] !== null ? item[apiKey] : 'N/A';
      });
      return row;
    });

    try {
      // Use Papa Parse to convert to CSV
      const csv = Papa.unparse(csvData, {
        header: true,
        quotes: true,
        quoteChar: '"',
        escapeChar: '"'
      });

      // Create and download the file
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${report.name}_${startDate || 'all'}_to_${endDate || 'all'}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      toast.success(`${report.name} downloaded successfully!`);
    } catch (error) {
      console.error('Error generating CSV:', error);
      toast.error('Failed to generate CSV file');
    }
  };

  return (
    <div className={`h-screen  flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      <div className="z-10">
        <NavBar />
      </div>
      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
            style={
              window.innerWidth < 768
                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                : {}
            }>
            <Sidebar />
          </div>
        )}
        <FullPageLoader
          isLoading={isPageLoading}
          message="Processing your request..."
        />
        <div className={`shadow-custom-light ml-3 mt-6 mb-6 custom-scrollbar mr-6 w-full rounded-custom overflow-y-auto dark:shadow-custom-dark p-4 ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : ''}`}>
          <div className="flex-1 overflow-auto p-6">
            <div className="mb-6 flex items-center justify-between">
              <button className="text-xl sm:text-2xl font-bold mb-4 bg-customPurple sm:mb-6 hover:bg-purple-700 text-white font-sans px-2 sm:px-6 py-2 sm:py-2 rounded h-[40px] w-full sm:w-full flex items-center justify-center">
                <TbReportSearch className="mr-2" size={24} />
                Report Dashboard
              </button> 
            </div>

            {error && (
              <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-md">
                <p className="text-red-800">{error}</p>
              </div>
            )}

            <div className="grid gap-6 md:grid-cols-2 dark:bg-darkmodeColor ">
              {reports.map((report) => (
                <div
                  key={report.name}
                  className="bg-white dark:bg-darkmodeColor rounded-custom shadow-custom-light dark:shadow-custom-dark transition-shadow p-6"
                >
                  <div className="mb-4">
                    <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                      {report.name}
                    </h2>
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                      {report.description}
                    </p>
                    <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
                      Columns: {Object.keys(report.columnMapping).length} fields
                    </p>
                  </div>

                  <div className="space-y-4">
                    <div className="grid grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                          Start Date
                        </label>
                        <input
                          type="date"
                          value={dateRanges[report.name].startDate}
                          onChange={(e) => handleDateChange(report.name, 'startDate', e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                        />
                      </div>
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                          End Date
                        </label>
                        <input
                          type="date"
                          value={dateRanges[report.name].endDate}
                          onChange={(e) => handleDateChange(report.name, 'endDate', e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                        />
                      </div>
                    </div>
                    <button
                      onClick={() => downloadCSV(report)}
                      disabled={isDownloadDisabled(report.name)}
                      className="w-full flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-customPurple hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <Download className="mr-2 h-4 w-4" />
                      Download CSV
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportsDropdown;